/**
 * @name monkeyPatch
 *
 * @description Monkey-patches any function on any object
 *
 * @example
 * import { monkeyPatch } from '@workbench/core';
 *
 * const customBeforeFn = (done: Function) => {
 *   console.log('BEFORE');
 *   done();
 * };
 *
 * const customAfterFn = () => {
 *   console.log('AFTER');
 * };
 *
 * monkeyPatch(this.el, 'remove', customBeforeFn, customAfterFn);
 */
const monkeyPatch = (scope, fnName, beforeFn, afterFn) => {
  const methodAlias = '__wb__' + fnName;
  scope[methodAlias] = scope[fnName];
  scope[fnName] = () => {
    const execute = () => {
      scope[methodAlias]();
      if (afterFn) {
        afterFn();
      }
    };
    if (beforeFn) {
      new Promise((resolve) => beforeFn(resolve)).then(execute);
    }
    else {
      execute();
    }
  };
};

export { monkeyPatch as m };
